import { defineNuxtPlugin } from 'nuxt/app';
import Client from 'shopify-buy';

export default defineNuxtPlugin((nuxtApp) => {
  const { code, shopifyApiAccessToken, shopifyApiDomain } = nuxtApp.$getCurrentLocaleConfig();

  const map = {
    'ch-fr': 'fr',
    'ch-de': 'de',
  };

  const config = {
    domain: shopifyApiDomain,
    storefrontAccessToken: shopifyApiAccessToken,
    language: map[code] ?? code,
  };

  return {
    provide: {
      shopifyBuyClient: () => Client.buildClient(config),
    },
  };
});
